import {createSlice} from "@reduxjs/toolkit";

export interface ISearchFormState {
    isLocationSearchOpen: boolean;
}

const initialState: ISearchFormState = {
    isLocationSearchOpen: false
};

export const searchFormSlice = createSlice({
    name: "searchForm",
    initialState,
    reducers: {
        openLocationSearch: (state) => {
            state.isLocationSearchOpen = true;
        },
        closeLocationSearch: (state) => {
            state.isLocationSearchOpen = false;
        }
    }
});

export const searchFormActions = searchFormSlice.actions;
